import { HttpClient } from "../HttpClient";
/**
 * * Post Content
 */
export const PostFavoriteAssetLabel = async (content) => {
	try {
		const { data } = await HttpClient.post("api/favoriteassetlabels/toggle", { ...content });
		return await Promise.resolve(data);
	} catch (err) {
		return Promise.reject(err);
	}
};
